// Auto-generated skeleton for DocumentContainer

export const DocumentContainer: Api.DocumentContainer = {
	id: 0,
	hp_id: null,
	document_files: [],
	comment: '',
	created: null,
	updated: null,
}
